export default {
  authPage: {
    backHome: "На главную",
    tabLogin: "Войти",
    tabRegister: "Регистрация",
    welcomeTitle: "Добро пожаловать",
    welcomeSubtitle: "Войдите в свой аккаунт",
    password: "Пароль",
    forgotPassword: "Забыли пароль?",
    passwordPlaceholder: "Введите пароль",
    loginSubmit: "Войти",
    loggingIn: "Входим...",
    esiaLogin: "Войти через Госуслуги",
    esiaDevNotice: "Вход через Госуслуги в разработке и скоро будет доступен.",
    forgotPasswordModalTitle: "Восстановление пароля",
    forgotPasswordModalHint: "Укажите email — отправим ссылку для сброса пароля.",
    forgotPasswordSubmit: "Отправить ссылку",
    forgotPasswordSending: "Отправляем...",
    forgotPasswordSuccess: "Если указанный адрес зарегистрирован, мы отправили письмо с инструкцией.",
    forgotPasswordClose: "Закрыть",
    resetPasswordTitle: "Новый пароль",
    resetPasswordSubtitle: "Придумайте новый пароль для входа.",
    resetPasswordSubmit: "Сохранить пароль",
    resetPasswordSaving: "Сохраняем...",
    resetPasswordSuccessTitle: "Пароль обновлён",
    resetPasswordSuccessHint: "Теперь можно войти с новым паролем.",
    resetPasswordGoLogin: "На страницу входа",
    resetLinkInvalidTitle: "Ссылка недействительна",
    resetLinkInvalidHint:
      "В адресе не хватает данных для сброса пароля. Запросите новое письмо на странице входа.",
    confirmEmailCheckingTitle: "Подтверждаем e-mail",
    confirmEmailCheckingHint: "Пожалуйста, подождите несколько секунд.",
    confirmEmailSuccessTitle: "Почта подтверждена",
    confirmEmailSuccessHint: "Теперь вы можете войти в аккаунт.",
    confirmEmailAutoRedirectHint: "Перенаправим на страницу входа через несколько секунд.",
    confirmEmailErrorTitle: "Не удалось подтвердить почту",
    confirmEmailGoLogin: "На страницу входа",
    confirmLinkInvalidTitle: "Ссылка подтверждения недействительна",
    confirmLinkInvalidHint:
      "В адресе не хватает данных для подтверждения почты. Запросите новое письмо на странице входа.",
    noAccount: "Нет аккаунта?",
    signUpLink: "Зарегистрироваться",
    createTitle: "Создать аккаунт",
    createSubtitle: "Присоединяйтесь к Ленинке Арт IP",
    lastName: "Фамилия",
    firstName: "Имя",
    middleName: "Отчество",
    email: "E-mail",
    passwordMin: "Минимум 8 символов",
    repeatPassword: "Повторите пароль",
    consent: {
      prefixTerms: "Я принимаю условия",
      linkTerms: "пользовательского соглашения",
      prefixPersonal: "Я даю согласие на",
      linkPersonal: "обработку персональных данных",
      prefixPrivacy: "Я ознакомлен(а) с",
      linkPrivacy: "политикой обработки персональных данных",
    },
    captchaMissingHint:
      "Для регистрации нужна Yandex SmartCaptcha: задайте VITE_YANDEX_SMARTCAPTCHA_SITEKEY в файле .env (см. .env.example).",
    createSubmit: "Создать аккаунт",
    registering: "Регистрируем...",
    hasAccount: "Уже есть аккаунт?",
    loginLink: "Войти",
    successTitle: "Аккаунт создан!",
    successHint: "Мы отправили письмо с подтверждением на",
    enterAccount: "Войти в аккаунт",
    footerNote: "Ленинка Арт IP © 2026",
    errors: {
      fillAll: "Заполните все поля.",
      fillRequired: "Заполните все обязательные поля.",
      passwordShort: "Пароль должен содержать не менее 8 символов.",
      passwordMismatch: "Пароли не совпадают.",
      agreeTerms: "Необходимо принять пользовательское соглашение.",
      agreePersonalData: "Необходимо дать согласие на обработку персональных данных.",
      agreePrivacyPolicy: "Необходимо принять политику обработки персональных данных.",
      captchaRequired: "Подтвердите, что вы не робот (пройдите проверку SmartCaptcha).",
      captchaConfig: "Капча не настроена на сайте. Обратитесь к администратору или задайте ключ в .env.",
      loginFailed: "Не удалось войти. Проверьте email и пароль.",
      emailNotConfirmed: "Почта не подтверждена. Подтвердите email по ссылке из письма и попробуйте снова.",
      registerFailed: "Не удалось зарегистрироваться. Попробуйте позже или проверьте данные.",
      resetFailed: "Не удалось сменить пароль. Ссылка могла устареть.",
      forgotSendFailed: "Не удалось отправить письмо. Попробуйте позже.",
      confirmFailed: "Не удалось подтвердить почту. Ссылка могла устареть или уже использоваться.",
    },
  },
}
